// extracted by mini-css-extract-plugin
export default {"center":"CampaignUpdatePage_center__HUqER","fullCenter":"CampaignUpdatePage_fullCenter__YV1TK","float":"CampaignUpdatePage_float__TwgEf","uu":"CampaignUpdatePage_uu__a8S6A"};